import React from 'react';

import './Trigger.scss';
import { useHitsPerPage } from "react-instantsearch-hooks-web";

function CustomHitsPerPage(props) {
    const { items, refine } = useHitsPerPage(props);
    const { value } = items.find(({ isRefined }) => isRefined) || {};

    return (
        <select
            onChange={(event) => {
                refine(Number(event.target.value));
            }}
            value={String(value)}
        >
            {items.map((item) => (
                <option key={item.value} value={String(item.value)}>
                    {item.label}
                </option>
            ))}
        </select>
    );
}

export class Trigger extends React.Component<any, any> {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="algolia-trigger">
                <div className="container">
                    <div>
                        <button className="btn-refine" onClick={() => { this.props.toggleFilterModal() }}>Refine</button>
                    </div>
                </div>
            </div>
        );
    }
}
